import React from 'react';
import PropTypes from 'prop-types';
import ProvidersView from './ProvidersView';
import { SFEntityID, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';

export default class ProvidersContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      providers: [],
      hasFetched: false
    };
  }

  componentDidMount() {
    const { id } = this.props;
    const URL = `../api/starfish/success-network/services/${id}/providers`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(({providers}) => this.setState({providers}))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({
      hasFetched: true,
      serviceId: id
    }));
  }

  render() {
    return <ProvidersView {...this.state} />;
  }
}

ProvidersContainer.propTypes = {
  id: SFEntityID.isRequired,
  onFailure: PropTypes.func.isRequired
};
